import { render } from "./PageBreadcrumbs.vue?vue&type=template&id=553f77bd"
import script from "./PageBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBreadcrumbs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/components/page-breadcrumbs/PageBreadcrumbs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "553f77bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('553f77bd', __exports__)) {
    api.reload('553f77bd', __exports__)
  }
  
  module.hot.accept("./PageBreadcrumbs.vue?vue&type=template&id=553f77bd", () => {
    api.rerender('553f77bd', render)
  })

}


export default __exports__